import React from 'react'
import { connectCurrentRefinements } from 'react-instantsearch-dom'
import { faUndo } from '@fortawesome/free-solid-svg-icons'

import Icon from '../../atoms/Icon'
import IconButton from '../../atoms/Button/IconButton'

const ResetButton = ({ items, refine, onClick, ...props }) => (
  <IconButton outline onClick={() => refine(items)} {...props}>
    <Icon icon={faUndo} />
  </IconButton>
)

export default connectCurrentRefinements(ResetButton)
